import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../api/axios";
import { toast } from "react-toastify";
import { readStoredJson } from "../../utilities/session";

// API fetch to get fresh user data
export const fetchUser = createAsyncThunk("profile/fetchUser", async (_, { rejectWithValue }) => {
  try {
    const res = await api.get("/api/user");
    const freshUser = res.data;
    localStorage.setItem("user", JSON.stringify(freshUser));
    return freshUser;
  } catch (error) {
    return readStoredJson("user", null);
  }
});

// Update Profile
export const updateProfile = createAsyncThunk(
  "profile/updateProfile",
  async ({ editData, userId }, { rejectWithValue }) => {
    try {
      const formData = new FormData();
      formData.append("name", editData.name);
      formData.append("email", editData.email);
      formData.append("mobile_number", editData.mobile_number);
      formData.append("voter_id", editData.voter_id);
      formData.append("role", editData.role);
      formData.append("status", editData.status);
      formData.append("_method", "PUT");

      if (editData.profile_photo_path instanceof File) {
        formData.append(
          "profile_photo_path",
          editData.profile_photo_path,
          editData.profile_photo_path.name
        );
      }

      const response = await api.post(`/api/users/${userId}`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      const updatedUser = response.data.user || response.data;
      localStorage.setItem("user", JSON.stringify(updatedUser));
      toast.success("Profile updated successfully!");
      return updatedUser;
    } catch (error) {
      return rejectWithValue(error.response?.data ?? { message: error.message });
    }
  }
);

const profileSlice = createSlice({
  name: "profile",
  initialState: {
    user: null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchUser.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchUser.fulfilled, (state, action) => {
        state.loading = false;
        state.user = action.payload;
      })
      .addCase(fetchUser.rejected, (state) => {
        state.loading = false;
        state.user = null;
      })
      .addCase(updateProfile.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateProfile.fulfilled, (state, action) => {
        state.loading = false;
        state.user = action.payload;
      })
      .addCase(updateProfile.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default profileSlice.reducer;
